let TemplatesIndexTourSteps  = {
  tourSteps: function() {
    return [
        {
          content: 'The templates page lists the email templates you have created. Email Templates can be used in both workflows and eBlasts.',
          target: '.help_icon_smaller',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: 'Use this button to create a new email template. You can also create email templates inline as your add or edit workflows.',
          target: '.new_template_btn',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: "This is the name of the email template. The people you are emailing don't see this.",
          target: '.template_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This category for the email. You can create and assign a category to an email to group common emails together.",
          target: '.template_category',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This subject for the email. You can include merge fields that will dynamically add the name or your lead or other information related to the lead.",
          target: '.template_subject',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times this template has been delivered.",
          target: '.email_stats_delivered',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times this template has been opened.",
          target: '.email_stats_opened',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times this template has been clicked.",
          target: '.email_stats_clicked',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: "This is the number of times a customer has unsubscribed using this template.",
          target: '.email_stats_unsubscribed',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times a customer has submitted a spam report using this template.",
          target: '.email_stats_spam_report',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times this template has bounced. Common reasons for emails bouncing are incorrect addresses or full mailboxes.",
          target: '.email_stats_bounced',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times this template has failed to send. Common reasons for email failures are incorrect addresses or full mailboxes.",
          target: '.email_stats_failed',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to edit an email template.",
          target: '.template_edit',
          placement: 'top',
          disableBeacon: true
        }
    ];
  }
};
export default TemplatesIndexTourSteps;
